import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { Observable, of } from 'rxjs';
import { WorkflowEvent } from '../models/workflowEvent';

export class ShowDataAction extends CustomAction<WorkflowEvent> {
  constructor(
    _text: string,
    isDelete = false,
  ) {
    super(_text, false, isDelete);
  }

  override isEnabled(item: WorkflowEvent): Observable<boolean> {
    if (!item.data || Object.keys(item.data as object).length === 0) {
      return of(false);
    } else {
      return of(true);
    }
  }
}
